import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'history',
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    { path: '/die-halle-der-runen-karten-shop-euro', component: require('../runeset-shop-euro-view') },
    { path: '/die-halle-der-runen-karten-shop', component: require('../runeset-shop-view') },
    { path: '/die-halle-der-runen-karten', component: require('../runeset-view') },
    { path: '/bought', component: require('../home-view') },
    { path: '/', component: require('../home-view') }
  ]
})


// WEBPACK FOOTER //
// ./lib/router/index.js